import * as React from 'react';
import {authorize} from "@athena-portal/components";
import CommonComplaintsPage from "./CommonComplaintsPage";

@authorize
export class LoggedInComplaintsPage extends React.Component {

    public render() {
        return <CommonComplaintsPage/>;
    }
}
